// routes
import { PATH_DASHBOARD, PATH_FAQ } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';


// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {

    user: icon('ic_user'),

    external: icon('ic_external'),
    menuItem: icon('ic_menu_item'),

    dashboard: icon('ic_dashboard'),
};

const navConfig = [

    {
        subheader: 'Algemeen',
        items: [
            // USER
            {
                title: 'dashboard',
                path: PATH_DASHBOARD.user.root,
                icon: ICONS.user,
                children: [
                    { title: 'account', path: PATH_DASHBOARD.user.account },
                    { title: 'invoices', path: PATH_DASHBOARD.user.invoices },

                ],

            },
            {
                title: 'FAQ',
                path: PATH_FAQ,
                icon: ICONS.external,
            },

        ],
    },


];

export default navConfig;
